import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { POST_URL } from '@utils/api/endpoints';

export interface CreateWebhookPayload {
  type: string;
  webhook_url: string;
  webhook_method: string;
  webhook_headers: string[];
  organization_id?: string;
}

export const useCreateWebhook = (customerId: number) => {
  const queryClient = useQueryClient();

  const createWebhook = (payload: CreateWebhookPayload) => {
    return Axios.post(
      `${POST_URL(customerId.toString()).customerWebhooks}`,
      payload
    );
  };

  return useMutation<void, AxiosError<BaseError>, CreateWebhookPayload>(
    async payload => {
      await createWebhook(payload);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['customerWebhooks', customerId]);
      },
      useErrorBoundary: false
    }
  );
};
